import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('hcc_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const p = window.location.pathname;
      if (p.startsWith('/admin') && p !== '/admin-login') {
        setToken(null); setRole(null);
        window.location.href = '/admin-login';
      } else if (p.startsWith('/recruiter') && p !== '/recruiter/login') {
        setToken(null); setRole(null);
        window.location.href = '/recruiter/login';
      }
    }
    return Promise.reject(err);
  }
);

export const setToken = (t) => { if (t) localStorage.setItem('hcc_token', t); else localStorage.removeItem('hcc_token'); };
export const getToken = () => localStorage.getItem('hcc_token');
export const setRole = (r) => { if (r) localStorage.setItem('hcc_role', r); else localStorage.removeItem('hcc_role'); };
export const getRole = () => localStorage.getItem('hcc_role');
